module.exports = __webpack_public_path__ + "assets/img/ic-popup-nodate.58171756.svg";